let base_config = {
	// api请求地址
	baseUrl: 'https://b2b.ruihaokang.cn/',
	// 图片域名
	imgDomain: 'https://b2b.ruihaokang.cn/',
	// 前端域名
	webDomain: 'https://b2b.ruihaokang.cn/',
	// 腾讯地图key
    mpKey: "",
	// 客服
    webSocket: "",
	// 本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
    pingInterval: 1500,
	// 客服地址
    keFuUrl: "",
    // 是否允许分仓与默认版本之间切换
    allowVersion_switch:false
};
export default base_config;